import React, { useEffect, useState } from "react";
import RestaurentCard from "./restaurant/RestaurentCard";
import Search from "./restaurant/Search";
import ShimmerUI from "./ShimmerUI";
import { Link } from "react-router-dom";
import useOnlineStatus from "./utils/hooks/useOnlineStatus";

// const resData = [
//   {
//     img: "https://tse1.mm.bing.net/th?id=OIP.Fl7GaNO771zxse2gNIAcowHaEK&pid=Api&P=0&h=180",
//     resName: "Meghana Foods",
//     cusion: "Biryani, North Indian, Asian",
//     star: 4.5,
//     deliveryTime: "20 Minutes",
//   },
//   {
//     img: "https://tse3.mm.bing.net/th?id=OIP.vCCcplp4WD5WA9HJW7FxYgHaEJ&pid=Api&P=0&h=180",
//     resName: "KFC",
//     cusion: "Chicken, Shouth Indian, Asian",
//     star: 4.4,
//     deliveryTime: "10 Minutes",
//   },
//   {
//     img: "https://tse2.mm.bing.net/th?id=OIP.1U7rm_HfMhxR1cYmY4-uZAHaEK&pid=Api&P=0&h=180",
//     resName: "Punjabi Dhaba",
//     cusion: "Daal Makhani, North Indian, Asian",
//     star: 4.0,
//     deliveryTime: "25 Minutes",
//   },
//   {
//     img: "https://tse4.mm.bing.net/th?id=OIP.RxJJDFk3_UTIRi8t0e-MvgHaEK&pid=Api&P=0&h=180",
//     resName: "KFC",
//     cusion: "Chicken, Shouth Indian, Asian",
//     star: 4.4,
//     deliveryTime: "10 Minutes",
//   },
//   {
//     img: "https://tse1.mm.bing.net/th?id=OIP.tNAzN9DM9wOF6BN5GhPrRQHaE7&pid=Api&P=0&h=180",
//     resName: "Meghana Foods",
//     cusion: "Biryani, North Indian, Asian",
//     star: 4.5,
//     deliveryTime: "20 Minutes",
//   },
//   {
//     img: "https://tse1.mm.bing.net/th?id=OIP.NPF0hOzbUO9fA27dUopmZQAAAA&pid=Api&P=0&h=180",
//     resName: "KFC",
//     cusion: "Chicken, Shouth Indian, Asian",
//     star: 4.4,
//     deliveryTime: "10 Minutes",
//   },
//   {
//     img: "https://tse1.mm.bing.net/th?id=OIP.fw8vIlXTVYUQd0HoscKY9wAAAA&pid=Api&P=0&h=180",
//     resName: "Punjabi Dhaba",
//     cusion: "Daal Makhani, North Indian, Asian",
//     star: 4.0,
//     deliveryTime: "25 Minutes",
//   },
//   {
//     img: "https://tse3.mm.bing.net/th?id=OIP.qB3fAS8vW-51G3vGoQ8g_gHaE8&pid=Api&P=0&h=180",
//     resName: "KFC",
//     cusion: "Chicken, Shouth Indian, Asian",
//     star: 4.4,
//     deliveryTime: "10 Minutes",
//   },
// ];

const Body = () => {
  const [listOfRestaurent, setListOfRestaurent] = useState([]);
  const [filteredListOfRestaurents, setFilteredListOfRestaurents] = useState(
    []
  );

  const [searchText, setSearchText] = useState("");

  const onlineStatus = useOnlineStatus();

  // const promotedRestaurants = withPromotedLable(RestaurentCard);

  const handleRatedRes = () => {
    const filteredRes = listOfRestaurent.filter(
      (res) => res?.info?.avgRating > 4.3
    );
    // console.log(filteredRes);
    setFilteredListOfRestaurents(filteredRes);
  };

  const handleSearchBox = () => {
    const filtereSearchRes = listOfRestaurent.filter((res) =>
      res?.info?.name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredListOfRestaurents(filtereSearchRes);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const data = await fetch(
      "https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.7040592&lng=77.10249019999999&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING"
    );

    const json = await data.json();

    setListOfRestaurent(
      json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants
    );
    setFilteredListOfRestaurents(
      json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants
    );
  };

  if (onlineStatus === false) {
    return (
      <h1 className="text-decor m-5 text-red-900">
        Hi, Look like you're offline!! Please check your internet connection!!
      </h1>
    );
  }
  // promotedRestaurants item?.info?.aggregatedDiscountInfoV3?.header

  return (
    <div className="">
      <Search
        handleRatedRes={handleRatedRes}
        searchText={searchText}
        setSearchText={setSearchText}
        handleSearchBox={handleSearchBox}
      />
      <div className="flex items-center justify-center flex-wrap gap-6 my-4">
        {listOfRestaurent.length === 0 ? (
          <>
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
            <ShimmerUI />
          </>
        ) : (
          filteredListOfRestaurents.map((item, index) => (
            <Link key={item?.info?.id} to={"/restaurant/" + item?.info?.id}>
              <RestaurentCard
                resName={item?.info?.name}
                cusion={item?.info?.cuisines}
                time={item?.info?.sla?.deliveryTime}
                rating={item?.info?.avgRating}
                IMGSRC={item?.info?.cloudinaryImageId}
                price={item?.info?.costForTwo}
              />
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default Body;
